// extracted by mini-css-extract-plugin
module.exports = {"providerInCompare":"ProviderCompareInfo_providerInCompare__2h0DQ"};